import React, { Suspense } from "react";
import { MetaMaskProvider } from "@metamask/sdk-react";
import { Provider } from "react-redux";
import MetaMaskSDKContainer from "./components/MetaMaskSDKContainer";
import configureStore from "./redux/store/configureStore";
import AppContainer from "./AppContainer";
import "./style.css";

const store = configureStore();

export default function App() {
  return (
    <Provider store={store}>
      <MetaMaskProvider
        debug={false}
        sdkOptions={{
          useDeeplink: false,
          checkInstallationImmediately: false,
          logging: {
            developerMode: false,
          },
          storage: {
            enabled: true,
          },
        }}
      >
        <MetaMaskSDKContainer>
          <Suspense fallback="loading...">
            <AppContainer />
          </Suspense>
        </MetaMaskSDKContainer>
      </MetaMaskProvider>
    </Provider>
  );
}
